import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Header from './pages/common/Header';
import AboutUs from './pages/About-Us';
import Home from './pages/common/Home';
import Signup from './pages/authentication-pages/Signup';
import Signin from './pages/authentication-pages/Signin';
import ForgotPassword from './pages/authentication-pages/ForgotPassword';
import ConfirmAccount from './pages/authentication-pages/confirmAccount';
import CreateNewPassword from './pages/authentication-pages/createNewPassword';
import AlertToast from './component/messages/message-toast-ms';
// import CursorBubbles from './pages/common-modules/CursorBubbles';
import VerificationAccount from './pages/authentication-pages/verificationAccount';
// import { Box, TextField } from '@mui/material';
// import { Button } from 'react-bootstrap';
import './App.css';
import Footer from './pages/common/Footer';
import TermsConditions from './pages/Terms&Conditions';
import ContactUs from './pages/Contact-us';
import Help from './pages/Help';
import PrivacyPolicy from './pages/Privacy-policy';
import SecHeader from './pages/common/SecHeader';
import { toast } from 'react-toastify';
import { DeleteTokenInIndexDB } from './utils/indexedDBUtils/delete-index-db';
import Styles from './styles/common/common.module.css';
import GirlsFashion from './pages/banner/girls/Girls_Fashion';
import GirlsFashionCategoryPage from './pages/banner/girls/GirlsFashionCategoryPage';
import BoysFashion from './pages/banner/boys/boys_Fashion';
import BoysFashionCategoryPage from './pages/banner/boys/BoysFashionCategoryPage';
import SearchResult from './component/common/SearchResult';
import CartItemList from './component/common/CartItemList';
import { RotateLoader } from 'react-spinners'
import { useSelector } from 'react-redux';
import ProfileSetting from './pages/common/setting';
import DiwaliDeals from './pages/products/DiwaliDeals';
import ReturnRefundPolicy from './pages/ReturnRefundPolicy';
import AdminProducts from './pages/admin/AdminProducts';
import ProductDetails from './pages/products/ProductDetails';
import ProductBrowser from './pages/products/ProductBrowser';
import ProductCollection from './pages/products/ProductCollection';
import ShippingPolicy from './pages/ShippingPolicy';
// Dummy components for routing (replace with your actual components)
const App = () => {

  const navigate = useNavigate();
  const account = useSelector((state: any) => state.user);
  const deleteAccountStatus = account?.statusCode;
  const [expanded, setExpanded] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const messageStore = useSelector((state: any) => state.messages) || []

  const handleLogout = async () => {
    await DeleteTokenInIndexDB('authToken');
    setIsAuthenticated(false);
    navigate('/'); // Navigate to new route
    toast.success('Logout successfully', {
      position: 'bottom-center',
      autoClose: 3000,
      className: Styles.toastCustom,
      bodyClassName: Styles.toastCustomBody,
      progressClassName: Styles.toastCustomProgress,
    });
  };

  useEffect(() => {
    if (deleteAccountStatus === 'success') {
      setIsAuthenticated(false);
    }
  }, [deleteAccountStatus]);
  // common message store
  // const auth = useSelector((state: any) => state.auth)
  return (
    <>
      {/* <CursorBubbles /> */}
      {/* <Container fluid> */}
      {/* <Header /> */}
      {messageStore.loading && (
        <>
          <div className='loading-overlay'>
            <RotateLoader
              loading={messageStore.loading}
              color={'#082C26'}
              aria-label='Loading Spinner'
            />
          </div>
        </>
      )}
      <Header handleLogout={handleLogout} isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} expanded={expanded} setExpanded={setExpanded} />
      <SecHeader
        handleLogout={handleLogout}
        isAuthenticated={isAuthenticated}
        setIsAuthenticated={setIsAuthenticated}
        expanded={expanded}
        setExpanded={setExpanded}
      />
      {/* <SecHeader /> */}
      {/* <Container> */}
      {/* Using React.lazy and Suspense for code splitting */}
      <React.Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* <Route path="/" element={<HomePage />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/cart" element={<CartPage />} /> */}
          {/* Add more routes as needed */}
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/profile-setting" element={<ProfileSetting />} />
          <Route path="/auth/sign-up" element={<Signup />} />
          <Route path="/auth/verify-otp" element={<ConfirmAccount />} />
          <Route path="/auth/sign-in" element={<Signin />} />
          <Route path="/auth/verify-account" element={<ForgotPassword />} />
          <Route path="/auth/verification-account" element={<VerificationAccount />} />
          <Route path="/auth/create-new-password" element={<CreateNewPassword />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/return-refund-policy" element={<ReturnRefundPolicy />} />
          <Route path="/help" element={<Help />} />

          {/* Banner all routes */}
          <Route path="/girls" element={<GirlsFashion />} />
          <Route path="/girls-fashion/:ageRange" element={<GirlsFashionCategoryPage />} />
          <Route path="/get-all-carts" element={<CartItemList />} />
          <Route path="/boys" element={<BoysFashion />} />
          <Route path="/boys-fashion/:ageRange" element={<BoysFashionCategoryPage />} />
          <Route
            path="/toys"
            element={
              <ProductBrowser
                categoryOverride="toys"
                titleOverride="Children's Toys"
                descriptionOverride="Browse active toy picks from the catalogue."
              />
            }
          />
          <Route
            path="/beauty"
            element={
              <ProductBrowser
                categoryOverride="beauty"
                titleOverride="Beauty Products"
                descriptionOverride="Browse active beauty picks from the catalogue."
              />
            }
          />
          {/* sec header routes */}
          {/* common routes */}
          <Route
            path="/limited-offers"
            element={
              <ProductCollection
                kind="priority"
                title="Limited Offers"
                eyebrow="CURATED PICKS"
                description="Browse active products selected for the catalogue. New published picks appear automatically."
              />
            }
          />
          <Route
            path="/latest-sellings"
            element={
              <ProductCollection
                kind="latest"
                title="Latest Picks"
                eyebrow="JUST ADDED"
                description="Discover the newest active products added to the catalogue."
              />
            }
          />
          <Route
            path="/mobiles"
            element={
              <ProductBrowser
                searchOverride="mobile"
                titleOverride="Mobile Products"
                descriptionOverride="Browse active mobile-related products from the catalogue."
              />
            }
          />
          <Route
            path="/best-sellers"
            element={
              <ProductCollection
                kind="best-sellers"
                title="Best Sellers"
                eyebrow="POPULAR PICKS"
                description="Explore active products selected as strong catalogue priorities."
              />
            }
          />
          <Route path="/search-result" element={<SearchResult />} />

          {/* diwali offer */}
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/product/:slug" element={<ProductDetails />} />
          <Route path="/products" element={<ProductBrowser />} />
          <Route path="/category/:category" element={<ProductBrowser />} />
          <Route path="/featured" element={<ProductCollection kind="featured" title="Featured Products" eyebrow="EDITOR PICKS" />} />
          <Route path="/trending" element={<ProductCollection kind="trending" title="Trending Products" eyebrow="POPULAR RIGHT NOW" />} />
          <Route path="/best-rated" element={<ProductCollection kind="best-rated" title="Best Rated Products" eyebrow="SHOPPER FAVOURITES" />} />
          <Route
            path="/diwali-deals"
            element={<DiwaliDeals />}
          />

        </Routes>
      </React.Suspense>
      <Footer />
      {/* </Container> */}
      <AlertToast />
    </>
  );
};

export default App;
